// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36wv7","delete":"styles_delete__2uO6n","update":"styles_update__1s2Sy","add":"styles_add__21bFO"};